export default __webpack_public_path__ + "f22ff0a223b77a652f5754522403606c.svg";